import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import {
	DRAFT_PROJECT_ID,
	EditorPreview,
	videoEditorStore,
} from 'modules/video-editor-module';
import { TProjectId } from 'modules/video-editor-module/types';

import { monitorsStore } from 'stores/monitors/monitor-list';
import { EditorLibrary } from './components/editor-library';
import { Timeline } from './components/timeline';

import './styles.scss';
import { FC, useEffect, useRef } from 'react';
import cx from 'classnames';
import { PlayerTopLine } from './components/top-line';
import { TimelineControls } from './components/timeline-controls';
import { Duration } from '../../components/duration';

const EditorProjectComponent: FC = () => {
	const timelineRef = useRef<HTMLDivElement>(null);
	const { id } = useParams<{ id: TProjectId }>();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		videoEditorStore.initProject({ projectId: id || DRAFT_PROJECT_ID });
	}, [id]);

	useEffect(() => {
		return () => {
			// cleanup
			videoEditorStore.initProject({});
		};
	}, []);

	useEffect(() => {
		void monitorsStore.getList();
	}, [monitorsStore.order]);

	useEffect(() => {
		if (videoEditorStore.project?.id) {
			const path = `/editor/project/${videoEditorStore.project.id}`;

			if (location.pathname !== path) {
				navigate(path, { replace: true });
			}
		}
	}, [location.pathname, navigate, videoEditorStore.project?.id]);

	return (
		<div className="editor__layout">
			<EditorLibrary timelineRef={timelineRef} />
			<div className={cx('editor__player player', videoEditorStore.view)}>
				<PlayerTopLine />
				<div className="player__video-container">
					<EditorPreview className="player__body" />
					<div className="player__time">
						<Duration seconds={videoEditorStore.currentSeconds} />
					</div>
				</div>
				<TimelineControls />
			</div>
			<Timeline innerRef={timelineRef} />
		</div>
	);
};

export const EditorProject = observer(EditorProjectComponent);
